import { composeIO } from 'react-compose-io'
import { itensRegularizacaoContaResumoIO } from './ItensRegularizacaoContaResumo.IO'
import { ItensRegularizacaoContaResumoView } from './ItensRegularizacaoContaResumo.View'

export const ItensRegularizacaoContaResumo = composeIO(ItensRegularizacaoContaResumoView, itensRegularizacaoContaResumoIO)
